<template>
  <div class="pageview">
    <PageTop />
    <PageHeader />
    <div class="pagemain">
      <router-view/>
    </div>
    <div class="footer">
      <div class="footer-box">
        <div class="footer-box-xgwz">
          <img src="../../assets/images/links_bg.png" class="footer-box-xgwz-linkimg" alt="">
          <a href="https://dxyq.stbrain.kjt.zj.gov.cn/" class="footer-box-a" target="_blank">浙江省大型仪器开放共享平台</a>
          <a href="http://www.zjut.edu.cn/main.htm" class="footer-box-a" target="_blank">浙江工业大学</a>
          <a href="http://www.sbc.zjut.edu.cn/" class="footer-box-a" target="_blank">实验室与资产管理处</a>
        </div>
        <div class="footer-box-2">
          <div class="footer-box-2-item">版权所有©浙江工业大学 实验室与资产管理处 地址：浙江省杭州市拱墅区潮王路18号浙江工业大学朝晖校区新机械楼A区7楼</div>
          <div class="footer-box-2-item">邮编：310014 联系电话：0571-88320434 部门邮箱：sbc@zjut.edu.cn</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageTop from './PageTop'
import PageHeader from './PageHeader'

export default {
  name: 'PageView',
  components: {
    PageTop,
    PageHeader,
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/global.less';
.pageview {
  width: 100%;
}
.pagemain {
  width: 100%;
}
.footer {
  width: 100%;
  background: rgb(239, 239, 239);
  // height: 93px;
  // min-width: 1440px;
  &-box {
    width: 1200px;
    margin: 0 auto;
    &-xgwz {
      color: #777;
      line-height: 55px;
      margin-bottom: 16px;
      font-size: 14px;
      font-weight: 400;
    }
    &-a {
      // width: 33%;
      // text-align: center;
      display: inline-block;
      padding: 5px 0px;
      border: 1px solid #d4d4d4;
      width: 200px;
      margin-left: 30px;
      text-align: center;
      line-height: 23px;
      color: #5a5a5a;
      background-color: #fff;
      &:hover {
        color: #fff;
        background-color: #0689db;
      }
      &:nth-child(2) {
        margin-left: 50px;
      }
    }
    &-2 {
      width: 100%;
      background-color: #004EA1;
      min-height: 70px;
      text-align: center;
      color: #fff;
      padding-top: 15px;
      line-height: 35px;
      &-item {
        // margin-bottom: 10px;
      }
    }
  }
}
</style>